import { render, staticRenderFns } from "./TheLogo.vue?vue&type=template&id=ccf523cc&scoped=true&"
import script from "./TheLogo.vue?vue&type=script&lang=js&"
export * from "./TheLogo.vue?vue&type=script&lang=js&"
import style0 from "./TheLogo.vue?vue&type=style&index=0&id=ccf523cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf523cc",
  null
  
)

export default component.exports